import { generatedId } from './helper';

export const kanbanBoardCols = [
  {
    title: 'To Do',
    id: generatedId(),
    issues: [
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20743',
        key: 'OD-69',
        fields: {
          summary: 'Frontend UI for Cart Modification',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20741',
            key: 'OD-67',
            fields: {
              summary: 'Modify Cart Contents',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20742',
        key: 'OD-68',
        fields: {
          summary: 'Backend Logic for Cart Updates',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20741',
            key: 'OD-67',
            fields: {
              summary: 'Modify Cart Contents',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20747',
        key: 'OD-73',
        fields: {
          summary: 'Backend Validation for Coupons',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20746',
            key: 'OD-72',
            fields: {
              summary: 'Apply Discount or Coupon',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20756',
        key: 'OD-82',
        fields: {
          summary: 'Testing Payment Integration',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20751',
            key: 'OD-77',
            fields: {
              summary: 'Checkout Payment Gateway Integration',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20755',
        key: 'OD-81',
        fields: {
          summary: 'Order Confirmation Page',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20751',
            key: 'OD-77',
            fields: {
              summary: 'Checkout Payment Gateway Integration',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20752',
        key: 'OD-78',
        fields: {
          summary: 'Integrate Payment Gateway APIs',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20751',
            key: 'OD-77',
            fields: {
              summary: 'Checkout Payment Gateway Integration',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20766',
        key: 'OD-92',
        fields: {
          summary: 'Restrict Admin Panel Access',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20763',
            key: 'OD-89',
            fields: {
              summary: 'Role-Based Access Control (Admin)',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20764',
        key: 'OD-90',
        fields: {
          summary: 'Define Role Management Logic',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20763',
            key: 'OD-89',
            fields: {
              summary: 'Role-Based Access Control (Admin)',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20784',
        key: 'OD-110',
        fields: {
          summary: 'Review Analytics for Insights',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          parent: {
            id: '20768',
            key: 'OD-94',
            fields: {
              summary: 'Customer Feedback and Review System',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20079',
                description:
                  'Epics track collections of related bugs, stories, and tasks.',
                name: 'Epic',
                subtask: false,
                avatarId: 10307,
                entityId: 'ce8160bf-ee9e-4fce-a218-afcde77daf40',
                hierarchyLevel: 1,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20779',
        key: 'OD-105',
        fields: {
          summary: 'Display Approved Reviews',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          parent: {
            id: '20768',
            key: 'OD-94',
            fields: {
              summary: 'Customer Feedback and Review System',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20079',
                description:
                  'Epics track collections of related bugs, stories, and tasks.',
                name: 'Epic',
                subtask: false,
                avatarId: 10307,
                entityId: 'ce8160bf-ee9e-4fce-a218-afcde77daf40',
                hierarchyLevel: 1,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20773',
        key: 'OD-99',
        fields: {
          summary: 'Handle Review Confirmation and Error Messaging',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20769',
            key: 'OD-95',
            fields: {
              summary: 'Customer Review Submission',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20772',
        key: 'OD-98',
        fields: {
          summary: 'Integrate Review System with Product Pages',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20769',
            key: 'OD-95',
            fields: {
              summary: 'Customer Review Submission',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20778',
        key: 'OD-104',
        fields: {
          summary: 'Add Notification for Moderation Results',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20774',
            key: 'OD-100',
            fields: {
              summary: 'Review Moderation by Admin',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20777',
        key: 'OD-103',
        fields: {
          summary: 'Integrate Moderation Actions with Logging System',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20774',
            key: 'OD-100',
            fields: {
              summary: 'Review Moderation by Admin',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20781',
        key: 'OD-107',
        fields: {
          summary: 'Design Frontend UI for Review Display',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20779',
            key: 'OD-105',
            fields: {
              summary: 'Display Approved Reviews',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20787',
        key: 'OD-113',
        fields: {
          summary: 'Design Analytics Dashboard UI',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20784',
            key: 'OD-110',
            fields: {
              summary: 'Review Analytics for Insights',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '21400',
        key: 'OD-136',
        fields: {
          summary: 'Improve UI/UX and Navigation Structure',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          assignee: null,
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '21403',
        key: 'OD-139',
        fields: {
          summary: 'Improve Customer Support Process and Documentation',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          assignee: null,
          status: {
            description: '',
            name: 'To Do',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
    ],
  },
  {
    title: 'In Progress',
    id: generatedId(),
    issues: [
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20750',
        key: 'OD-76',
        fields: {
          summary: 'Testing Coupon Application',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20746',
            key: 'OD-72',
            fields: {
              summary: 'Apply Discount or Coupon',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20749',
        key: 'OD-75',
        fields: {
          summary: 'Discount Calculation and Cart Update',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20746',
            key: 'OD-72',
            fields: {
              summary: 'Apply Discount or Coupon',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20748',
        key: 'OD-74',
        fields: {
          summary: 'Frontend UI for Coupon Application',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20746',
            key: 'OD-72',
            fields: {
              summary: 'Apply Discount or Coupon',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20754',
        key: 'OD-80',
        fields: {
          summary: 'Secure Payment Processing Backend',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20751',
            key: 'OD-77',
            fields: {
              summary: 'Checkout Payment Gateway Integration',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20753',
        key: 'OD-79',
        fields: {
          summary: 'Frontend Payment Options UI',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20751',
            key: 'OD-77',
            fields: {
              summary: 'Checkout Payment Gateway Integration',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20761',
        key: 'OD-87',
        fields: {
          summary: 'Testing Tax and Shipping Calculation',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20757',
            key: 'OD-83',
            fields: {
              summary: 'Tax and Shipping Calculation',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20760',
        key: 'OD-86',
        fields: {
          summary: 'Dynamic Fee Update on Address Change',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20757',
            key: 'OD-83',
            fields: {
              summary: 'Tax and Shipping Calculation',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20759',
        key: 'OD-85',
        fields: {
          summary: 'Shipping Fee Calculation',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20757',
            key: 'OD-83',
            fields: {
              summary: 'Tax and Shipping Calculation',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20758',
        key: 'OD-84',
        fields: {
          summary: 'Tax Calculation Logic',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20757',
            key: 'OD-83',
            fields: {
              summary: 'Tax and Shipping Calculation',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20763',
        key: 'OD-89',
        fields: {
          summary: 'Role-Based Access Control (Admin)',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          parent: {
            id: '20762',
            key: 'OD-88',
            fields: {
              summary: 'Order Management System',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20079',
                description:
                  'Epics track collections of related bugs, stories, and tasks.',
                name: 'Epic',
                subtask: false,
                avatarId: 10307,
                entityId: 'ce8160bf-ee9e-4fce-a218-afcde77daf40',
                hierarchyLevel: 1,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20767',
        key: 'OD-93',
        fields: {
          summary: 'Logging Admin Actions',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20763',
            key: 'OD-89',
            fields: {
              summary: 'Role-Based Access Control (Admin)',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20765',
        key: 'OD-91',
        fields: {
          summary: 'Create Admin Panel UI',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20763',
            key: 'OD-89',
            fields: {
              summary: 'Role-Based Access Control (Admin)',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20774',
        key: 'OD-100',
        fields: {
          summary: 'Review Moderation by Admin',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          parent: {
            id: '20768',
            key: 'OD-94',
            fields: {
              summary: 'Customer Feedback and Review System',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20079',
                description:
                  'Epics track collections of related bugs, stories, and tasks.',
                name: 'Epic',
                subtask: false,
                avatarId: 10307,
                entityId: 'ce8160bf-ee9e-4fce-a218-afcde77daf40',
                hierarchyLevel: 1,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20769',
        key: 'OD-95',
        fields: {
          summary: 'Customer Review Submission',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          parent: {
            id: '20768',
            key: 'OD-94',
            fields: {
              summary: 'Customer Feedback and Review System',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20079',
                description:
                  'Epics track collections of related bugs, stories, and tasks.',
                name: 'Epic',
                subtask: false,
                avatarId: 10307,
                entityId: 'ce8160bf-ee9e-4fce-a218-afcde77daf40',
                hierarchyLevel: 1,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20771',
        key: 'OD-97',
        fields: {
          summary: 'Design and Implement Review Submission UI',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20769',
            key: 'OD-95',
            fields: {
              summary: 'Customer Review Submission',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20770',
        key: 'OD-96',
        fields: {
          summary: 'Implement Review Submission Backend',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20769',
            key: 'OD-95',
            fields: {
              summary: 'Customer Review Submission',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20776',
        key: 'OD-102',
        fields: {
          summary: 'Create Review Moderation UI',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20774',
            key: 'OD-100',
            fields: {
              summary: 'Review Moderation by Admin',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20775',
        key: 'OD-101',
        fields: {
          summary: 'Implement Review Moderation Backend',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20774',
            key: 'OD-100',
            fields: {
              summary: 'Review Moderation by Admin',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20783',
        key: 'OD-109',
        fields: {
          summary: 'Add Review Sorting Options',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20779',
            key: 'OD-105',
            fields: {
              summary: 'Display Approved Reviews',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20782',
        key: 'OD-108',
        fields: {
          summary: 'Integrate Backend API with Frontend for Review Display',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20779',
            key: 'OD-105',
            fields: {
              summary: 'Display Approved Reviews',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20780',
        key: 'OD-106',
        fields: {
          summary: 'Create Backend Endpoint for Fetching Approved Reviews',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20779',
            key: 'OD-105',
            fields: {
              summary: 'Display Approved Reviews',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
            displayName: 'ADITYA SHARMA',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20788',
        key: 'OD-114',
        fields: {
          summary: 'Integrate Backend Data with Analytics Dashboard',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20784',
            key: 'OD-110',
            fields: {
              summary: 'Review Analytics for Insights',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20786',
        key: 'OD-112',
        fields: {
          summary: 'Integrate Sentiment Analysis for Reviews',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20784',
            key: 'OD-110',
            fields: {
              summary: 'Review Analytics for Insights',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '20785',
        key: 'OD-111',
        fields: {
          summary: 'Backend System for Review Data Aggregation',
          issuetype: {
            id: '20080',
            description:
              'Subtasks track small pieces of work that are part of a larger task.',
            name: 'Subtask',
            subtask: true,
            avatarId: 10316,
            entityId: '6448daee-6b33-49b8-a98d-580a9e027215',
            hierarchyLevel: -1,
          },
          parent: {
            id: '20784',
            key: 'OD-110',
            fields: {
              summary: 'Review Analytics for Insights',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20078',
                description:
                  'Stories track functionality or features expressed as user goals.',
                name: 'Story',
                subtask: false,
                avatarId: 10315,
                entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
                hierarchyLevel: 0,
              },
            },
          },
          assignee: {
            accountId: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
            emailAddress: 'choudharysarthak124@gmail.com',
            displayName: 'Sarthak Choudhary',
            active: true,
            timeZone: 'Asia/Calcutta',
            accountType: 'atlassian',
          },
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '21401',
        key: 'OD-137',
        fields: {
          summary: 'Resolve Technical Glitches and Enhance System Performance',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          assignee: null,
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
      {
        expand:
          'operations,versionedRepresentations,editmeta,changelog,renderedFields',
        id: '21402',
        key: 'OD-138',
        fields: {
          summary:
            'Enhance Feature & Functionality: Improved Filtering and Reporting',
          issuetype: {
            id: '20078',
            description:
              'Stories track functionality or features expressed as user goals.',
            name: 'Story',
            subtask: false,
            avatarId: 10315,
            entityId: 'abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f',
            hierarchyLevel: 0,
          },
          parent: {
            id: '20768',
            key: 'OD-94',
            fields: {
              summary: 'Customer Feedback and Review System',
              status: {
                description: '',
                name: 'To Do',
                id: '20070',
                statusCategory: {
                  id: 2,
                  key: 'new',
                  colorName: 'blue-gray',
                  name: 'To Do',
                },
              },
              priority: {
                name: 'Medium',
                id: '3',
              },
              issuetype: {
                id: '20079',
                description:
                  'Epics track collections of related bugs, stories, and tasks.',
                name: 'Epic',
                subtask: false,
                avatarId: 10307,
                entityId: 'ce8160bf-ee9e-4fce-a218-afcde77daf40',
                hierarchyLevel: 1,
              },
            },
          },
          assignee: null,
          status: {
            description: '',
            name: 'In Progress',
            id: '20070',
            statusCategory: {
              id: 2,
              key: 'new',
              colorName: 'blue-gray',
              name: 'To Do',
            },
          },
        },
      },
    ],
  },
];
